import styles from "./FiltersBadgeLazyLoaderStyles.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";

const FiltersBadgeLazyLoader = () => (
  <>
    <div className={styles.lazyloadFilterContainer} />
  </>
);

export default wrapperHOC(FiltersBadgeLazyLoader, {
  componentName: "FiltersBadgeLazyLoader-FiltersBadgeGroup-FilterSection-SearchPage",
  showForChina: true,
});
